/* Trustpilot's account-enabled public TrustBox data. Refresh at most every
 * 48 hours per browser; failures retain the last known score and count. */
(() => {
  'use strict';
  if (window.cfTrustpilotStarted) return;
  window.cfTrustpilotStarted = true;
  const unit = '6602ab7bc80091d789272bf0';
  const key = `cf-trustpilot-${unit}-v1`, ttl = 48 * 60 * 60 * 1000;
  let current;
  function valid(data) {
    return data && Number.isFinite(data.score) && data.score >= 1 && data.score <= 5 && Number.isInteger(data.count) && data.count >= 0 && Number.isFinite(data.updatedAt);
  }
  function render(data) {
    if (!valid(data)) return;
    current = data;
    document.querySelectorAll('[data-cf-trustpilot]').forEach(el => {
      el.querySelectorAll('[data-tp-score]').forEach(node => node.textContent = data.score.toFixed(1));
      el.querySelectorAll('[data-tp-count]').forEach(node => node.textContent = data.count.toLocaleString('en-US'));
      el.querySelectorAll('[data-tp-stars]').forEach(node => {
        node.setAttribute('aria-label', `${data.score.toFixed(1)} out of 5 stars`);
        node.style.setProperty('--tp-fill', `${Math.round(data.score * 2) / 2 / 5 * 100}%`);
      });
    });
  }
  async function update() {
    let cached;
    try { cached = JSON.parse(localStorage.getItem(key)); } catch (_) { /* Storage is optional. */ }
    if (valid(cached)) {
      render(cached);
      if (Date.now() - cached.updatedAt >= 0 && Date.now() - cached.updatedAt < ttl) return;
    }
    try {
      const response = await fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=${unit}&locale=en-US`, {signal:AbortSignal.timeout(8000)});
      if (!response.ok) return;
      const body = await response.json(), business = body.businessUnit;
      if (business?.identifyingName !== 'circularfash.com') return;
      const data = {score:business.trustScore, count:business.numberOfReviews?.total, updatedAt:Date.now()};
      if (!valid(data)) return;
      render(data);
      try { localStorage.setItem(key, JSON.stringify(data)); } catch (_) { /* Private browsing. */ }
    } catch (_) { /* Keep the server-rendered or cached figures. */ }
  }
  document.addEventListener('shopify:section:load', () => current && render(current));
  update();
})();
